import { useEffect } from 'react';
import _ from 'lodash';
import fetch from '@adc/fetch';
// @ts-ignore next
import { trackInstrumentPageLoad } from '@adc/analytics';
import logger from '@adc/logger';
import r2wc from '@r2wc/react-to-web-component';
import { getWebComponentName, getTheme } from '../utils';
import { DEFAULT_GEO, FEATURE_FLAGS_NEEDED, EVENT_TYPES } from '../constants';
import useFreshnessDetection from '@adc/ui-adc/hooks/useFreshnessDetection';
const fetchUserAndFlags = () => fetch
    .forAuctionGraph({
    query: `
        query webComponentGetCurrentUserAndFeatureFlags {
          feature_flags(filters:{flagKeys:${JSON.stringify(FEATURE_FLAGS_NEEDED)}})
          current_user {
            first_name
            party_id
          }
        }
      `,
})
    .then(res => {
    const user = res.body.errors?.some((e) => e.path?.includes('current_user'))
        ? null
        : res.body.data.current_user;
    const featureFlags = res.body.errors?.some((e) => e.path?.includes('feature_flags'))
        ? {}
        : res.body.data.feature_flags;
    return {
        user,
        featureFlags,
    };
})
    .catch(error => {
    logger.error('Error fetching user and flags:', error?.statusText || error); // eslint-disable-line
    return null;
});
const fetchGeo = () => fetch('/apps/api/geo')
    .then(res => {
    if (res.status !== 200) {
        return null;
    }
    const body = res.body;
    return body;
})
    .catch(error => {
    logger.error('Error fetching geo:', error?.statusText || error); // eslint-disable-line
    return null;
});
/**
 * This component attempts to get the current user (using current auth cookie if available)
 * and if found sets it on the window object and notifies the rest of the app.
 */
const WrappedComponent = () => {
    useFreshnessDetection(); // eslint-disable-line
    useEffect(() => {
        if (!window.STATE)
            window.STATE = {};
        const fetchData = async () => {
            const result = await fetchUserAndFlags();
            if (!_.isEmpty(result?.user)) {
                window.STATE.currentUser = {
                    ...result?.user,
                    first_name: result?.user?.first_name || '',
                    logged_in: true,
                };
            }
            else {
                delete window.STATE.currentUser;
            }
            /**
             * Note, this expands the scope of "getUser", but as this is called once on each page load, and has the user
             * data available, it makes sense for now.  Perhaps at some point we refactor this component to be more of a
             * general 'initialize' component.
             */
            trackInstrumentPageLoad(result?.user || undefined, getTheme().productLine); // eslint-disable-line
            window.STATE.featureFlags = result?.featureFlags || {};
            window.dispatchEvent(new Event(EVENT_TYPES.CURRENT_USER_AND_FLAGS_UPDATED));
            const geo = await fetchGeo();
            window.STATE.geo = !_.isEmpty(geo) ? geo : DEFAULT_GEO;
            window.dispatchEvent(new Event(EVENT_TYPES.GEO_UPDATED));
        };
        // fetch on mount...
        fetchData().catch(error => console.error('Error in fetchData:', error));
        // Fetch on page visibility change
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                fetchData().catch(error => console.error('Error in fetchData:', error));
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return null;
};
const WebComponent = r2wc(WrappedComponent, {
    props: {},
});
customElements.define(getWebComponentName('get-user'), WebComponent);
